/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV3PriceProviderV2,
  UniswapV3PriceProviderV2Interface,
} from "../UniswapV3PriceProviderV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Factory",
        name: "_factory",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "periodForAvgPrice",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "blockTime",
            type: "uint8",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV2.PriceCalculationData",
        name: "_priceCalculationData",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    name: "NewBlockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "period",
        type: "uint32",
      },
    ],
    name: "NewPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IUniswapV3Pool[]",
        name: "pools",
        type: "address[]",
      },
    ],
    name: "PoolsForAsset",
    type: "event",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "adjustOracleCardinality",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetOldestTimestamp",
    outputs: [
      {
        internalType: "uint32[]",
        name: "oldestTimestamps",
        type: "uint32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_blockTime",
        type: "uint8",
      },
    ],
    name: "changeBlockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
    ],
    name: "changePeriodForAvgPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "observationsStatus",
    outputs: [
      {
        internalType: "bool",
        name: "bufferFull",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "enoughObservations",
        type: "bool",
      },
      {
        internalType: "uint16",
        name: "currentCardinality",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV2.PricePath[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceCalculationData",
    outputs: [
      {
        internalType: "uint32",
        name: "periodForAvgPrice",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "quotePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_currentObservationIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_currentObservationCardinality",
        type: "uint16",
      },
    ],
    name: "resolveOldestObservationTimestamp",
    outputs: [
      {
        internalType: "uint32",
        name: "oldestTimestamp",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Factory",
    outputs: [
      {
        internalType: "contract IUniswapV3Factory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "verifyPools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV2.PricePath[]",
        name: "path",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3PriceProviderV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3PriceProviderV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3PriceProviderV2__factory extends ContractFactory {
  constructor(...args: UniswapV3PriceProviderV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3PriceProviderV2";
  }

  deploy(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProviderV2.PriceCalculationDataStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3PriceProviderV2> {
    return super.deploy(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      overrides || {}
    ) as Promise<UniswapV3PriceProviderV2>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProviderV2.PriceCalculationDataStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      overrides || {}
    );
  }
  attach(address: string): UniswapV3PriceProviderV2 {
    return super.attach(address) as UniswapV3PriceProviderV2;
  }
  connect(signer: Signer): UniswapV3PriceProviderV2__factory {
    return super.connect(signer) as UniswapV3PriceProviderV2__factory;
  }
  static readonly contractName: "UniswapV3PriceProviderV2";
  public readonly contractName: "UniswapV3PriceProviderV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3PriceProviderV2Interface {
    return new utils.Interface(_abi) as UniswapV3PriceProviderV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3PriceProviderV2 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniswapV3PriceProviderV2;
  }
}
